import React, { useState, useRef } from "react";
import NoRecordsAvailable from "../../../components/NoRecordsAvailable";
import { putApi } from "../../../utils/api";
import { toast } from "react-toastify";
import { API_CSAT_RATING } from "../../../config/Endpoints";
import Cookies from "js-cookie";

const CSATViewTeamMembersRatingTable = ({ projectDetails, userData }) => {
  const membersData = projectDetails?.csatMembers || [];
  const [members, setMembers] = useState([...membersData]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedRating, setEditedRating] = useState(null);
  const accessToken = Cookies.get("accessToken");
  const updatingRef = useRef(false);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc")
      direction = "desc";

    const sorted = [...members].sort((a, b) => {
      const valA = a[key];
      const valB = b[key];
      if (valA == null) return direction === "asc" ? -1 : 1;
      if (valB == null) return direction === "asc" ? 1 : -1;

      if (typeof valA === "string")
        return direction === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      if (typeof valA === "number")
        return direction === "asc" ? valA - valB : valB - valA;
      return 0;
    });

    setSortConfig({ key, direction });
    setMembers(sorted);
  };

  const handleEditClick = (index) => {
    setEditingIndex(index);
    setEditedRating(members[index].rating);
  };

  const handleCancelClick = () => {
    setEditingIndex(null);
    setEditedRating(null);
  };

  const handleUpdateClick = async (member, index) => {
    if (editedRating == null || isNaN(editedRating)) {
      toast.error("Please enter a valid rating.");
      return;
    }
    if (updatingRef.current) return;
    updatingRef.current = true;

    const payload = {
      projectId: projectDetails.projectId,
      employeeId: member.employeeId,
      rating: parseFloat(editedRating),
      createdBy: userData?.id,
    };

    try {
      const response = await putApi(
        `${API_CSAT_RATING}/${member.id}`,
        payload,
        accessToken
      );
      const updatedMembers = [...members];
      updatedMembers[index].rating = parseFloat(editedRating);
      setMembers(updatedMembers);
      setEditingIndex(null);
      toast.success(response?.data?.message || "Rating updated successfully.");
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to update rating.");
    } finally {
      updatingRef.current = false;
    }
  };

  if (members.length === 0) return <NoRecordsAvailable />;

  return (
    <div className="row">
      <div className="row mb-3">
        <h6 className="mb-2">Team Members Ratings</h6>
      </div>
      <div className="table-responsive rounded-lg">
        <table className="resume custom">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }} className="col-md-1">
                S.No.
              </th>
              <th
                style={{ textAlign: "left", cursor: "pointer" }}
                onClick={() => handleSort("employeeName")}
              >
                Employee Name{" "}
                {sortConfig.key === "employeeName"
                  ? sortConfig.direction === "asc"
                    ? "▲"
                    : "▼"
                  : ""}
              </th>
              <th
                style={{ textAlign: "center", cursor: "pointer" }}
                onClick={() => handleSort("rating")}
                className="col-md-2"
              >
                Rating{" "}
                {sortConfig.key === "rating"
                  ? sortConfig.direction === "asc"
                    ? "▲"
                    : "▼"
                  : ""}
              </th>
              <th style={{ textAlign: "center" }} className="col-md-2">
                {" "}
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {members.map((row, index) => {
              const isEditing = editingIndex === index;
              return (
                <tr key={index}>
                  <td style={{ textAlign: "center" }}>{index + 1}</td>
                  <td style={{ textAlign: "left" }}>
                    {row.employeeName || "—"}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {isEditing ? (
                      <input
                        type="text"
                        step="0.1"
                        min="1"
                        max="5"
                        value={editedRating}
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^(?:[1-4](?:\.\d{0,1})?|5(?:\.0?)?)$/;

                          if (value === "" || regex.test(value)) {
                            setEditedRating(value);
                          }
                        }}
                        style={{
                          width: "80px",
                          textAlign: "center",
                          padding: "3px",
                        }}
                        className="border"
                      />
                    ) : row.rating ? (
                      row.rating.toFixed(1)
                    ) : (
                      "—"
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {isEditing ? (
                      <>
                        <a
                          href="javascript:void(0)"
                          className="fw-bolder me-3"
                          onClick={() => handleUpdateClick(row, index)}
                          style={{
                            pointerEvents:
                              updatingRef.current || editedRating === row.rating
                                ? "none"
                                : "auto",
                            opacity:
                              updatingRef.current || editedRating === row.rating
                                ? 0.5
                                : 1,
                          }}
                        >
                          Update
                        </a>
                        <a
                          href="javascript:void(0)"
                          className="fw-bolder text-danger"
                          onClick={handleCancelClick}
                        >
                          Cancel
                        </a>
                      </>
                    ) : (
                      <a
                        href="javascript:void(0)"
                        className="fw-bolder"
                        onClick={() => handleEditClick(index)}
                      >
                        Edit
                      </a>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CSATViewTeamMembersRatingTable;
